module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp2_1.d86cf278.png";